import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { JsmGsConfigProviderEntrypointProps } from './JsmGsConfigProvider.entrypoint.types.tsx';

type RequestTypesConfigProviderEntrypointComponent = EntryPointComponent<
	{},
	{},
	JsmGsConfigProviderEntrypointProps,
	{} | null
>;

export const requestTypesConfigProviderEntrypoint: EntryPoint<
	RequestTypesConfigProviderEntrypointComponent,
	{}
> = createEntryPoint({
	root: JSResourceForInteraction<RequestTypesConfigProviderEntrypointComponent>(
		/* webpackChunkName: "ai-rovo-actions-jsm-gs-request-types-provider" */ './RequestTypesConfigProviderEntry.tsx',
	),
	getPreloadProps: () => ({}),
});
